import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "kind",
    "companyName",
    "countryCode",
    "vin",
    "tin",
    "tinLabelIndividual",
    "tinLabelCompany",
  ]

  connect() {
    this.update()
  }

  update() {
    this.#show(
      this.tinLabelIndividualTarget,
      this.kindTarget.value == "" || this.#isIndividual(),
    )

    this.#show(this.tinLabelCompanyTarget, this.#isBusiness())

    // Updates here should also:
    // - be applied to the component as hidden defaults
    // - match validations in the LegalEntity model
    this.#show(this.companyNameTarget, this.#isCompany())
    this.#show(this.vinTarget, this.#isBusiness() && this.#isEuropean())
    this.#show(this.tinTarget, this.#isBusiness() || this.#isEuropean())
  }

  // https://cults.slack.com/archives/C07SBTY6XV4/p1763472252488239?thread_ts=1763394969.669039&cid=C07SBTY6XV4
  #isCompany() {
    return this.kindTarget.value == "company"
  }

  #isBusiness() {
    return (
      this.kindTarget.value == "company" ||
      this.kindTarget.value == "individual_company"
    )
  }

  #isIndividual() {
    return this.kindTarget.value == "individual"
  }

  #isEuropean() {
    const country = this.countryCodeTarget.selectedOptions[0]
    return country?.dataset?.legalEntityEuropean == "true"
  }

  #show(element, show) {
    if (show) {
      element.removeAttribute("hidden")
    } else {
      element.setAttribute("hidden", true)
    }
  }
}
